import { Component } from '@angular/core';

import {
    AlertController, LoadingController, ModalController, NavController, NavParams,
    ViewController
} from 'ionic-angular';

import { ConferenceData } from '../../../providers/conference-data';
import { MissionsData } from '../../../providers/missions-data';
import { UiData } from '../../../providers/ui-data';
import {UserData} from "../../../providers/user-data";

import { JobSelectForm } from '../../utils/job-select/job-select';
import { Geolocation } from '@ionic-native/geolocation';
import {LocationSelectForm} from "../../utils/location-select/location-select";


declare var google: any;

@Component({
    selector: 'page-account-setting',
    templateUrl: 'settings.html'
})
export class AccountSettingsPage {
    tracks: Array<{name: string, isChecked: boolean}> = [];
    settings : any;
    test:any;
    lengthRange : any ;
    locationSelectModal: any;
    loading: any = false;
    inited: any = false;
    currently_loading: any = false;
    notifications:any = {};

    constructor(
        public confData: ConferenceData,
        public navParams: NavParams,
        public viewCtrl: ViewController,
        public userData: UserData,
        public missionsData: MissionsData,
        public uiData: UiData,
        public modalCtrl: ModalController,
        private geolocation: Geolocation,
        public loadingCtrl: LoadingController,
        public alertCtrl: AlertController,
        public nav: NavController
    ) {
        this.notifications = {};
    }
    ngAfterViewInit() {

        this.getUserInfos();
    }
    sectorsAsList(){

    }
    getUserInfos() {
        var that = this;
        this.userData.load().subscribe(user => {
            that.settings = this.userData.get('settings');
            if(!that.settings)that.settings = Object.assign({},that.userData.defaultRegistriesValues.settings);
            if(!that.settings.notifications)that.settings.notifications=Object.assign({},that.userData.defaultRegistriesValues.settings.notifications);
            if(!that.settings.appVersion)that.settings.appVersion=Object.assign({},that.userData.defaultRegistriesValues.settings.appVersion);
        });

    }
    resetFilters() {
        var that = this;
        let prompt = this.alertCtrl.create({
            title: 'Réinitialiser les paramètres',
            message: "Souhaitez vous continuer ?",
            buttons: [
                {
                    text: 'Oui, réinitialiser',
                    handler: data => {
                        that.settings.notifications = Object.assign({},that.userData.defaultRegistriesValues.settings.notifications);
                    }
                },
                {
                    text: 'Annuler',
                    handler: data => {
                    }
                }
            ]
        });
        prompt.present();
    }
    applySettings() {
        var that = this;
        that.userData.set('settings',that.settings);
        that.dismiss(true);
    }
    setLoading(state,msg=""){
        if(msg == "")msg = 'Chargement des paramètres ...';
        if(state)
        {
            this.currently_loading = true;
            this.loading = this.loadingCtrl.create({
                content: msg
            });
            this.loading.present();
        }
        else if(this.loading){
            this.currently_loading = false;
            this.loading.dismiss();
        }
    }
    dismiss(data?: any) {
        // using the injected ViewController this page
        // can "dismiss" itself and pass back data
        this.viewCtrl.dismiss(data);
    }
    checkVersion()
    {
        this.userData.checkVersion();
    }
    logout() {
        this.userData.logout();
        this.nav.setRoot('LoginPage');
    }
    openCGU()
    {
        window.open('https://www.novaterim.com/conditions-generales', '_system');
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/settings/settings.ts